import { api } from '../api/client';
import type { RecipeSettingsRequest, RecipeSettingsResponse } from '@familyhub/shared';

/**
 * The recepten config screen's server state: the household's chosen recipe model
 * and the selectable catalog (with a rough per-recipe euro estimate). Online-only,
 * like the rest of the recepten AI — these call recepten's own URLs, not a
 * cross-module seam.
 */
export function getRecipeSettings(): Promise<RecipeSettingsResponse> {
  return api<RecipeSettingsResponse>('/api/v1/recepten/settings');
}

export function putRecipeSettings(body: RecipeSettingsRequest): Promise<RecipeSettingsResponse> {
  return api<RecipeSettingsResponse>('/api/v1/recepten/settings', { method: 'PUT', body });
}
